export const controlDisplayTypeList = [
    // {displayType: "button"},
    {displayType: "checkbox"},
    // {displayType: "dropdown"},
    // {displayType: "textbox"},
    // {displayType: "numberbox"},
];

export default controlDisplayTypeList;